/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";

interface TableHeadColumnProps {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
    colSpan: number;
}

const TableHeadColumn = (props: TableHeadColumnProps) => {
    return (
        <th className={clsx("px-1.5 last:pr-3 first:pl-3 py-3 text-left last:text-right", props.className && props.className)} colSpan={props.colSpan}>
            {props.children}
        </th>
    );
};

export default TableHeadColumn;
